import { Component, Input } from '@angular/core';
import { TranslationPipe } from '../../../shared/pipes';
import { ConnectionDetail } from '../../../core/models';
import { DetourComponent } from '../../../shared/components';

@Component({
  selector: 'app-connection-icons',
  standalone: true,
  imports: [DetourComponent, TranslationPipe],
  templateUrl: './connection-icons.component.html'
})
export class ConnectionIcons {
  @Input() connection: ConnectionDetail | undefined = undefined;

  get isAccessible(): boolean {
    return this.hasCode("H");
  }
  get isWorkDayConn(): boolean {
    return this.hasCode("X");
  }
  get isReservable(): boolean {
    return this.hasCode("R");
  }
  get isBaggage(): boolean {
    return this.hasCode("L");
  }
  get isPlug(): boolean {
    return this.hasCode("ł");
  }
  get isWifi(): boolean {
    return this.hasCode("©");
  }

  /**
   * Vrátí true, pokud vlastnost "fixedCodes" obsahuje zadaný kód.
   * @param code Kód vlastnosti
   */
  private hasCode(code: string): boolean {
    return this.connection?.fixedCodes?.some(c => c.fontChar == code) ?? false;
  }
}
